<template>
  <section>
    <ViewLoader v-if="loading"/>
    <div class="container intro-section center-page-content" v-else>
      <div class="row">
        <div class="col text-center">

          <div v-if="orderIdValid">
            <Icon name="grCheckCircleBroken" width="36" class="mb-3"/>
            <h2 class="title">
              {{ $t('pages.checkout_success.title') }}
            </h2>
          </div>
          <div v-else>
            <Icon name="grAlertTriangle" width="36" class="mb-3"/>
            <h2 class="title">
              {{ $t('pages.checkout_error.title') }}
            </h2>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>


<script>
import ViewLoader from "@/components/ViewLoader";
import {mapActions} from "vuex";

export default {
  data() {
    return {
      orderIdValid: false,
      loading: true
    }
  },
  components: {
    ViewLoader
  },

  beforeMount() {
    window.scrollTo(0, 0);
  },

  async mounted() {
    if (this.$route.query.redirect_status === 'succeeded') {
      await this.checkValidityOrder(this.$route.query.order)
    } else {
      this.orderIdValid = false
    }
    this.loading = false
  },
  methods: {
    ...mapActions('cartDigitalItems', ['fetchOrder','deleteCart']),
    async checkValidityOrder(orderId) {
      if (!orderId) return;
      const order = await this.fetchOrder(orderId);
      if (order) {
        this.orderIdValid = true;
        await this.deleteCart();
      } else {
        this.orderIdValid = false;
      }
    }
  },

  computed: {}
}
</script>
